import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-account-contexts-card',
  templateUrl: './account-contexts-card.component.html',
  styleUrls: ['./account-contexts-card.component.scss']
})
export class AccountContextsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enableCount: any;
  disableCount: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() { }

  ngAfterContentChecked() {
    this.spinnerService.show('apisecrets-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('apisecrets-counts-spinner');
      this.showCounter = true;
      this.enableCount = this.data.availableContexts;
      this.disableCount = this.data.unavailableContexts;
    } else if ('-' === this.data) {
      this.enableCount = '-';
      this.disableCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('apisecrets-counts-spinner');
    }
  }
}
